const formatAddress = (address, isCountryName) => {
  const house = !!address.house_number ? ` ${address.house_number}` : '';
  const country = isCountryName && !!address.country_name ? `, ${address.country_name}` : '';

  return (`${address.street_name}${house}${address.street_name || house ? ', ' : ''}${address.city_name}${country}`);
};

export default formatAddress;
